import { DateTime } from 'luxon';

export const debug = (...args: any[]) => {
  if (process.env.NODE_ENV === 'production') return;
  console.log('[KWIXL-DEBUG]', DateTime.now().toFormat('MM/dd/yy hh:mm:ss a'), ...args);
}